export class UpdateActionRequest {
  Name: string;
  Description: string;
}
